/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Row, Tabs } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import TabPane from 'antd/lib/tabs/TabPane';
import JustificacionGrupalGeneral from './JustificacionGrupalGeneral';
import JustificacionGrupalForms from './JustificacionGrupalForms';

const JustificacionGrupal = ({ permission }) => {
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [parentData, setParentData] = useState({});
  const [autorizarRechazar, setAutorizarRechazar] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(0);

  const changeToForms = (dataId, _autorizarRechazar) => {
    setParentData({ _dataId: dataId });
    setAutorizarRechazar(_autorizarRechazar);
    setCurrentTabKey('captura');
  };

  const refreshGeneral = () => {
    setRefreshFlag((prev) => prev + 1);
  };

  const updateTable = () => {
    refreshGeneral();
    setCurrentTabKey('general');
  };

  const onTabChange = (key) => {
    if (key === 'captura' && currentTabKey !== 'captura') {
      setParentData({});
      setAutorizarRechazar(false);
    }
    setCurrentTabKey(key);
  };

  return (
    <Row className="container">
      <Tabs type="card" activeKey={currentTabKey} onChange={onTabChange}>
        <TabPane
          tab={(
            <span>
              <InfoCircleOutlined />
              {' '}
              General
            </span>
          )}
          key="general"
          forceRender
        >
          <JustificacionGrupalGeneral
            permission={permission}
            changeToForms={changeToForms}
            refreshFlag={refreshFlag}
          />
        </TabPane>
        <TabPane
          tab={(
            <span>
              <InfoCircleOutlined />
              {' '}
              Captura
            </span>
          )}
          key="captura"
          forceRender
        >
          <JustificacionGrupalForms
            datos_padre={parentData}
            autorizar_rechazar={autorizarRechazar}
            updateTable={updateTable}
            refreshGeneral={refreshGeneral}
          />
        </TabPane>
      </Tabs>
    </Row>
  );
};

export default JustificacionGrupal;
